import { CssBaseline, ThemeProvider } from '@mui/material';

import { Navigation } from './navigation';
import { Alert } from './services/alert/Alert';
import { AlertProvider } from './services/alert/AlertProvider';
import { AuthManager } from './services/auth/AuthManager';
import { Modal } from './services/modal/Modal';
import { ModalProvider } from './services/modal/ModalProvider';
import { ReduxProvider } from './services/redux';
import { theme } from './services/theme';
// import { useFontLoader } from './services/theme/useFontLoader';

export const App = () => {
  // useFontLoader();

  return (
    <AlertProvider>
      <ModalProvider>
        <ReduxProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthManager>
              <Navigation />
            </AuthManager>
            <Alert />
            <Modal />
          </ThemeProvider>
        </ReduxProvider>
      </ModalProvider>
    </AlertProvider>
  );
};
